export default __webpack_public_path__ + "static/media/neslisah-kula.376c890e.png";